import React, { useState, useEffect } from "react";

import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import axios from "axios";

import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker
} from "@material-ui/pickers";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import LoadingModal from "../../../components/Modal/LoadingModal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Preloader from "../../../components/Preloader/Preloader";

import { useParams, useHistory, NavLink } from "react-router-dom";

const useStyles = makeStyles({
	field: {
		width: "100%",
		marginBottom: "1rem"
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem"
	},
	date: {
		width: "100%",
		marginBottom: "1rem"
	},
	buttonContainer: {
		textAlign: "right"
	},
	card: {
		marginBottom: "1rem"
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px"
	},
	title: {
		marginTop: "0",
		color: "#4f537e",
		fontWeight: "700",
		fontSize: "1.1rem"
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8"
	},    
});

const Collection = () => {
	const classes = useStyles();
	const x = 0;
	useEffect(() => {
		//
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		//
		getPaymentList();
	}, []);

	const [selectedDate, setSelectedDate] = React.useState(new Date());
	const [payments, setPayments] = useState(null);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [amount, setAmount] = useState('');
	const [reference, setReference] = useState("");
	const [payopt, setPayopt] = useState("");
	const [idNo, setIdNo] = useState("");

	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	const [showModal, setShowModal] = useState(false);

	let history = useHistory();

	const getPaymentList = async () => {
		await axios
			.get(process.env.REACT_APP_API_URL + "collection_payment_list", {
			})
			.then(res => {
				setPayments(res.data.payment_list);
			})
			.catch(error => {
			//console.log(error.message);
			});
	};

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	const selectPaymentProps = {
		options: payments,
		getOptionLabel: option => option.description
	};

	const handleDateChange = date => {
		setSelectedDate(date);
	};

	// refno:123456
	// payamt:2000
	// payopt:1
	// trandate:2021-04-14
	// idno:00189912
	// jc_uname:superuser
	// jc_u_idno:DAVAOHQ

	const save_collection = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true);
		const formData = new FormData();
		formData.append("refno", reference);
		formData.append("payamt", amount);
		formData.append("payopt", payopt);
		formData.append("trandate", format(selectedDate, "yyyy-MM-dd"));
		formData.append("idno", idNo);
		formData.append("jc_uname", get_cookies("username"));
		formData.append("jc_u_idno", get_cookies("branchidno"));
		//show 3rd ui, sales order payment
		await axios
			.post(process.env.REACT_APP_API_URL + "save_collection", formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			})
			.then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Added new Collection");
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push("/sales");
				}, 2000);
			})
			.catch(function (error) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Something went wrong: " + error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500);
			});
	};

	useEffect(() => {
		if (idNo && selectedDate && (amount>0) && reference && payopt) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [idNo, selectedDate, amount, reference, payopt]);

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/sales"}>
					<h4 style={{ color: "#1D1C1A" }}>Sales</h4>
				</NavLink>
				<ArrowForwardIosIcon
					style={{ paddingLeft: "10px", paddingRight: "10px" }}
				/>
				<h4>Collection</h4>
			</div>
			{payments?(			<div className="page-container">
				<MessageBox
					in={showMsgBox}
					content={msgBoxContent}
					type={msgType}
				/>
				<Card className={classes.card}>
					<LoadingModal showModal={showModal} />
					<div className={classes.cardHeader}>
						<Grid
							container
							spacing={0}
							style={{ justifyContent: "flex-end" }}
						>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Collection
								</div>
								<div className={classes.title}>Collection</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{ textAlign: "right" }}
							></Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							></Grid>
							<Grid container spacing={2}>
								<Grid item xs="12" lg="4" xl="3">
									<form noValidate autoComplete="off">
										<MuiPickersUtilsProvider
											utils={DateFnsUtils}
										>
											<KeyboardDatePicker
												disableToolbar
												variant="inline"
												format="MMM dd, yyyy"
												id="date-picker-inline"
												label="Date picker inline"
												value={selectedDate}
												onChange={handleDateChange}
												inputVariant="outlined"
												margin="normal"
												className={classes.date}
												KeyboardButtonProps={{
													"aria-label": "change date"
												}}
												InputProps={{
													readOnly: true,
												  }}
											/>
										</MuiPickersUtilsProvider>
										<TextField
											id="outlined-basic"
											label="Enter Id No."
											variant="outlined"
											type="text"
											className={classes.field}
											value={idNo} //to avoid label overlapping bug
											onChange={e => {
												setIdNo(e.target.value);
											}}
										/>
										<Autocomplete
											{...selectPaymentProps}
											id="auto-complete-1"
											autoComplete
											style={{ marginBottom: "1rem" }}
											includeInputInList
											renderInput={params => (
												<TextField
													{...params}
													label="Select Payment Option"
													variant="outlined"
												/>
											)}
											onChange={(event, newValue) => {
												if (
													!newValue == "" ||
													!newValue == null
												){
													//console.log(newValue.description);
													setPayopt(newValue.id);
												}else{
													//console.log('hehe');
													setPayopt(null);
												}
											}}
										/>
										<TextField
											id="outlined-basic"
											label="Amount"
											variant="outlined"
											type="number"
											className={classes.field}
											defaultValue={1}
											value={amount} //to avoid label overlapping bug
											onKeyPress={(e) => { 
												if(e.key == '-'){
													e.preventDefault();
												}
											 }}
											onChange={e => {
												setAmount(e.target.value);
											}}
											onBlur={(e) => {
												if(parseFloat(e.target.value) > 0){
													setAmount(e.target.value);
												}else{
													setAmount(0);
												}
												//console.log(e.target.value);
											}}
										/>
										<TextField
											id="outlined-basic"
											label="Reference..."
											variant="outlined"
											type="text"
											className={classes.field}
											value={reference} //to avoid label overlapping bug
											onChange={e => {
												setReference(e.target.value);
											}}
										/>
									</form>
								</Grid>
							</Grid>
						</Grid>
					</div>
				</Card>
				<div className={classes.buttonContainer}>
					<ColorButton
						disabled={btnDisabled}
						onClick={save_collection}
						variant="contained"
						color="primary"
						classes={{
						root: classes.root, 
						disabled: classes.disabled}}
					>
						Save Collection Record
					</ColorButton>
				</div>
			</div>
		):(<Preloader/>)}

		</div>
	);
};

export default Collection;
